import { Input, Textarea } from '@nextui-org/react'

export default function CompanyTechnicalCapabilities({ formData, handleChange, userUUID, isForUser }: any) {
  return (
    <div className="flex flex-col gap-4">
      <Textarea
        isRequired
        label="Core Service Areas"
        labelPlacement="outside"
        variant="bordered"
        placeholder="all domains in which the agency excels (web, mobile, e-commerce, integration, cloud, UX, etc.)"
        classNames={{
          inputWrapper: 'flex flex-1',
        }}
        value={formData?.coreServiceArea}
        onChange={(e) => handleChange?.('coreServiceArea', e.target.value)}
      />
      <Input
        isRequired
        label="Programming Languages & Frameworks"
        variant="bordered"
        placeholder="Indicate proficiency across languages (Java, C#, Python, JS/TS, PHP, etc.) and frameworks (Spring, .NET, React, Angular, Laravel)"
        value={formData?.programmingLanguages}
        onChange={(e) => handleChange?.('programmingLanguages', e.target.value)}
      />
      <div className="flex flex-row gap-4">
        <Textarea
          isRequired
          label="Tools & DevOps Practices"
          labelPlacement="outside"
          variant="bordered"
          placeholder="Outline source-control, CI/CD, code-review, automated-testing, and Agile frameworks. Mature DevOps pipelines are often explicitly weighted in technical evaluation."
          classNames={{
            inputWrapper: 'flex flex-1',
          }}
          value={formData?.toolsPractices}
          onChange={(e) => handleChange?.('toolsPractices', e.target.value)}
        />
        <Textarea
          isRequired
          label="Cloud & Infrastructure Expertise"
          labelPlacement="outside"
          variant="bordered"
          placeholder="Outline source-control, CI/CD, code-review, automated-testing, and Agile frameworks. Mature DevOps pipelines are often explicitly weighted in technical evaluation."
          classNames={{
            inputWrapper: 'flex flex-1',
          }}
          value={formData?.cloudInfra}
          onChange={(e) => handleChange?.('cloudInfra', e.target.value)}
        />
      </div>
      <Textarea
        isRequired
        label="Specialized Expertise"
        labelPlacement="outside"
        variant="bordered"
        placeholder=" Detail any differentiating know-how (AI/ML, data science, blockchain, AR/VR, SAP, embedded). "
        classNames={{
          inputWrapper: 'flex flex-1',
        }}
        value={formData?.specializedExpertise}
        onChange={(e) => handleChange?.('specializedExpertise', e.target.value)}
      />
      <Textarea
        isRequired
        label="Technical Partnerships & Accreditations"
        labelPlacement="outside"
        variant="bordered"
        placeholder="List official partner statuses (Microsoft Gold, AWS Advanced, Google Cloud Partner) and relevant OSS contributions. "
        classNames={{
          inputWrapper: 'flex flex-1',
        }}
        value={formData?.techPartnership}
        onChange={(e) => handleChange?.('techPartnership', e.target.value)}
      />
    </div>
  )
}
